import { WeightUnit } from "@/Common/Utilities/Units/Units";
import { ObstetricalFileSubsequentVisitsTableRow } from "@/Patient/Components/MedicalNote/Obstetric/Form/Common/Subcomponent/ObstetricalFileSubsequentVisitsTableRow";
import { ObstetricsCalculator } from "@/Patient/Helpers/ObstetricsCalculator";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";
import { BritishColumbiaObstetricalVisit } from "@/Patient/Models/ObstetricalFile/BritishColumbia/Part2/BritishColumbiaObstetricalVisit";

class BritishColumbiaObstetricalFileSubsequentVisitsTableRow extends ObstetricalFileSubsequentVisitsTableRow<BritishColumbiaObstetricalFileForm, BritishColumbiaObstetricalVisit> {
    protected readonly urineKey = "Urine";
    protected readonly fundusKey = "Fundus";

    protected get columnKeys(): string[] {
        return [
            this.dateKey,
            this.gestationalAgeKey,
            this.bloodPressureKey,
            this.urineKey,
            this.weightKey,
            this.fundusKey,
            this.fetalHearthRateKey,
            this.fetalMovementKey,
            this.presentationKey,
            this.commentsKey,
            this.nextVisitKey,
            this.initialsKey
        ];
    }

    protected get fieldLimits(): { [columnKey: string]: number } {
        return {
            [this.urineKey]: 7,
            [this.weightKey]: 7,
            [this.fundusKey]: 7,
            [this.fetalHearthRateKey]: 7,
            [this.fetalMovementKey]: 7,
            [this.presentationKey]: 5,
            [this.nextVisitKey]: 6,
            [this.initialsKey]: 6
        };
    }

    protected get weightUnit(): WeightUnit {
        return this.props.form.Metadata.SubsequentVisitsTableWeightUnit;
    }

    protected renderCell(columnKey: string): JSX.Element {
        const visit = this.props.visit;

        switch (columnKey) {
            case this.urineKey: return (
                <td key={columnKey}>
                    {this.controlRenderer.renderTextbox({
                        value: visit.Urine,
                        onChange: value => this.props.onChange(this.mutateVisit(v => v.Urine = value)),
                        className: "table-textbox",
                        maxLength: this.fieldLimits[this.urineKey]
                    })}
                </td>
            );
            case this.fundusKey: return (
                <td key={columnKey}>
                    {this.controlRenderer.renderTextbox({
                        value: visit.Fundus?.toString(),
                        onChange: value => this.props.onChange(this.mutateVisit(v => v.Fundus = value && parseFloat(value))),
                        className: "table-textbox",
                        isNumeric: true,
                        maxLength: this.fieldLimits[this.fundusKey]
                    })}
                </td>
            );
            default: return super.renderCell(columnKey);
        }
    }

    protected mutateVisitDate(mutate: (visit: BritishColumbiaObstetricalVisit) => void): BritishColumbiaObstetricalVisit {
        return this.mutateVisit(v => {
            mutate(v);
            const form = this.props.form;
            v.GestationalAge = ObstetricsCalculator.calculateWeeksOfGestation(
                form.Section12.ConfirmedEstimatedDateOfDelivery
                ?? form.Section3.EstimatedDateOfBirthByUltrasound
                ?? form.Section3.EstimatedDateOfBirthByLastMenstrualPeriod,
                v.Date
            );
        });
    }
}

export { BritishColumbiaObstetricalFileSubsequentVisitsTableRow };
